export const DEACTIVATE_FEATURES_IN_BULK_START =
  'DEACTIVATE_FEATURES_IN_BULK_START';
export const DEACTIVATE_FEATURES_IN_BULK_SUCCESS =
  'DEACTIVATE_FEATURES_IN_BULK_SUCCESS';
export const DEACTIVATE_FEATURES_IN_BULK_ERROR =
  'DEACTIVATE_FEATURES_IN_BULK_ERROR';
